export interface Layout {
    id: number;
    value: string;
    name: string;
    created_at: string;
    updated_at: string;
}
